import React from 'react';
import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import DeleteRequestsPage from '../deleteRequestPage/DeleteRequestsPage';

export const DeleteRequestsPageRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={
        <RouteWithTitle title="Delete Requests - Wisestep">
          <DeleteRequestsPage />
        </RouteWithTitle>
      }
    ></Route>
  </Routes>
);
